export default __webpack_public_path__ + "static/media/020-stethoscope.4dc68bea.svg";